import { useState, useEffect } from "react";

/* Fix CO (2026-09-13): "al momento de digitar el monto que salga ya con los puntos
   de miles para evitar error de tipeo" (Edson, 13/09). Un <input type="number">
   muestra 13000000000 sin separadores y un cero de más pasa desapercibido: así se
   cargó un avance de 1.000.000% sobre un contrato de Gs. 1.300.000 en INVICTA.
   Este campo escribe los puntos mientras se tipea, solo acepta dígitos y devuelve
   el número limpio. `onChange` avisa en cada tecla (campo controlado) y `onCommit`
   al salir del campo (para guardar una sola vez, como los onBlur de la grilla). */
const fmt = (n) => {
  if (n === "" || n === null || n === undefined || isNaN(Number(n))) return "";
  return new Intl.NumberFormat("es-PY", { maximumFractionDigits: 0 }).format(Math.round(Number(n)));
};
const digitos = (s) => String(s ?? "").replace(/\D/g, "");

export default function MontoInput({ value, onChange, onCommit, placeholder = "Monto", className = "", ...rest }) {
  const [texto, setTexto] = useState(() => fmt(value));

  useEffect(() => {
    setTexto(prev => (Number(digitos(prev) || 0) === Number(value || 0) ? prev : fmt(value)));
  }, [value]);

  const handleChange = (e) => {
    const solo = digitos(e.target.value);
    setTexto(solo === "" ? "" : fmt(solo));
    onChange?.(solo === "" ? 0 : Number(solo));
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={texto}
      onChange={handleChange}
      onBlur={() => onCommit?.(Number(digitos(texto) || 0))}
      placeholder={placeholder}
      className={`text-right tabular-nums ${className}`}
      {...rest}
    />
  );
}
